import { Component, Input } from '@angular/core';
import {
  IOdbBillProductSplit,
  OdbCoverDetailDivisionType,
} from '@dch/billing-business-logic';

@Component({
  selector: 'my-bill-odb-subscription-product-split',
  templateUrl: './odb-subscription-product-split.component.html',
  standalone: false,
})
export class OdbSubscriptionProductSplitComponent {
  @Input() productSplit: Array<IOdbBillProductSplit>;
  @Input() totalAmount: string;
  @Input() divisionType: OdbCoverDetailDivisionType;
  @Input() billingAccountNumber: string;
  @Input() documentReference: string;
}
